"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSyncTransform = (transform) => transform.length === 1;
exports.isSyncValidate = (validate) => validate.length === 1;
//# sourceMappingURL=types.js.map